export class LineConfig
{
    color: string;
    width?: number;
}
